import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'
import { showToastNotification } from 'shared/store/actions/toastNotification'

import { RootAction } from 'typesafe-actions'

type func = (payload: any) => void

export const useToast = (): func => {
  const dispatch = useDispatch<Dispatch<RootAction>>()

  return (payload) => dispatch(showToastNotification(payload))
}
